
    <template>
        <div>
          <button @click="goBack" class="back-button">
            <span class="back-arrow">&lt;&nbsp;</span>返回
          </button>
          <div class="site-grid">
              <div class="site-item" v-for="site in siteList" :key="site.siteCode" @click="showDetailPage(site.siteCode)">
                  <img :src="site.siteImg" :alt="site.siteName" class="site-image" />
                  <div class="product-info">
                    <h3>{{ site.siteName }}</h3>
                  </div>
              </div>
          </div>

      </div>


    </template>


  
  <script>
  export default {
    props:['productId'],
    mounted(){
      console.log('商品已添加到购物车:', this.productId);
      this.getSites(this.productId);
    },
    data() {
      return {
        siteList: [
          {
            id: 1,
            name: '商品1',
            price: 199.99,
            image: 'path/to/product1.jpg',
          }
          // ... 添加更多商品数据
        ],
      };
    },
    methods: {
      showDetailPage(code){
        this.$emit('getBack',code)
      },
      goBack(){
        console.log("ssss")
        this.$emit('getBack','backSchool')
      },
      getSites(code){
        this.getRequest('/yl/site/imags/'+code).then(resp => {
            if (resp) {
                this.siteList = resp.data;
            }
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .site-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 20px;
  }
  
  .site-item {
    flex: 0 0 20%; /* 控制每个商品项的宽度，这里设置为24%，可根据需要调整 */
    margin-bottom: 20px; /* 商品项之间的间距 */
    padding: 5px 10px;
    text-align: center;
  }
  
  .site-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 5px;
    margin-bottom: 10px; /* 图片与商品信息之间的间距 */
  }
  
  .site-info {
    padding: 10px;
  }
  
  .add-to-cart-btn {
    display: block;
    margin: auto;
    padding: 10px;
    background-color: #4CAF50; /* 按钮背景色 */
    color: white; /* 按钮文字颜色 */
    border: none;
    cursor: pointer;
  }
  
  .add-to-cart-btn:hover {
    background-color: #45a049; /* 鼠标悬停时的背景色 */
  }
  .back-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #f4f4f4;
  color: #333;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.back-button:hover {
  background-color: #e0e0e0;
}
  </style>